import React, { Fragment } from 'react';
import moment from 'moment-timezone';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import EmptyCurrentActiveJobs from './EmptyCurrentActiveJobs';
import Jobs from './Jobs';

import Subheader from '../common/Subheader';

const StyledSubheader = styled(Subheader)`
  margin-bottom: ${props => props.theme.spacing[2]};
`;

const StyledCurrentJobs = styled.div`
  margin-bottom: ${props => props.theme.spacing[2]};
`;

const StyledUpcomingJobs = styled.div`
  margin-bottom: ${props => props.theme.spacing[3]};
`;

const ActiveJobs = ({
  currentJobs,
  onJobCardClick,
  upcomingJobs,
  onTransferJobClick,
  navigateExternal,
}) => {
  const orderedCurrentJobs = currentJobs.sort((jobA, jobB) => moment(jobA.finishTime) - moment(jobB.finishTime));

  const orderedUpcomingJobs = upcomingJobs.sort((jobA, jobB) => moment(jobA.startTime) - moment(jobB.startTime));

  return (
    <Fragment>
      { orderedCurrentJobs.length || orderedUpcomingJobs.length ?
        <>
          <StyledCurrentJobs>
            <Jobs
              jobs={orderedCurrentJobs}
              onJobCardClick={onJobCardClick}
              onTransferJobClick={onTransferJobClick}
              navigateExternal={navigateExternal}
            />
          </StyledCurrentJobs>
          { !!orderedUpcomingJobs.length &&
            <Fragment>
              <StyledSubheader>Upcoming</StyledSubheader>
              <StyledUpcomingJobs>
                <Jobs
                  jobs={orderedUpcomingJobs}
                  onJobCardClick={onJobCardClick}
                  onTransferJobClick={onTransferJobClick}
                />
              </StyledUpcomingJobs>
            </Fragment>
          }
        </>
        : <EmptyCurrentActiveJobs navigateExternal={navigateExternal} />
      }
    </Fragment>
  );
};

ActiveJobs.propTypes = {
  currentJobs: PropTypes.arrayOf(PropTypes.object),
  upcomingJobs: PropTypes.arrayOf(PropTypes.object),
  onJobCardClick: PropTypes.func.isRequired,
  onTransferJobClick: PropTypes.func.isRequired,
  navigateExternal: PropTypes.func,
};

ActiveJobs.defaultProps = {
  currentJobs: [],
  upcomingJobs: [],
  navigateExternal: () => {},
};

export default ActiveJobs;
